import React, { ReactNode } from "react";
import { Button } from "./components/base_ui/inputs/button";
import { Enterprise } from "@carbon/icons-react";
import { KIND, ButtonProps as BaseButtonProps } from "baseui/button";

export default function SsoButton({
  csrfToken,
  children,
  connection,
  className,
  disabled = false,
  buttonType = KIND.primary,
  onSubmit,
  queryParams = {},
  showIcon = true,
  buttonText,
  dataAnalyticsId,
}: {
  csrfToken: string;
  children?: ReactNode;
  className?: string;
  connection?: string;
  disabled?: boolean;
  buttonType?: BaseButtonProps["kind"];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit?: (event: any) => Promise<void>;
  queryParams?: { [key: string]: string };
  showIcon?: boolean;
  buttonText?: string;
  dataAnalyticsId?: string;
}) {
  let actionPath = `/api/users/auth/auth0?connection=${connection}`;

  for (const key in queryParams) {
    actionPath += `&${key}=${queryParams[key]}`;
  }

  return (
    <form className={className} action={actionPath} method="post" name="sso_sign_up_form">
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      {children}
      <Button
        className="ssoButton"
        disabled={disabled}
        isStretched={true}
        buttonType={buttonType}
        leftIcon={showIcon ? <Enterprise size={32} /> : undefined}
        onClick={onSubmit}
        data-test="sign-in-sso-button"
        data-analytics-id={dataAnalyticsId}
      >
        {buttonText}
      </Button>
    </form>
  );
}
